// Per-cell state byte. It moves with the cell and its meaning depends on the cell's material:
// - powders: how far the grain has fallen (decides when it may slide sideways);
// - liquids: flow flags (LIQ_* in index.ts: direction, turned back once, resting).
// Anything that writes a new material into a cell resets its byte to 0.
import { createGrid, type Grid } from './grid';

export type CellStateMatrix = Grid;

export function createCellState(w: number, h: number): CellStateMatrix {
  return createGrid(w, h);
}
